<div class="search-container">
  <div class="search-input-wrapper">
    <input
      pInputText
      type="text"
      class="search-input"
      [placeholder]="placeholder | transloco"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchTermChanged($event)"
      (keydown.enter)="onEnterKeyPressed()"
      (keydown.escape)="onEscapeKeyPressed()"
      [disabled]="disabled"
    />
    <button
      type="button"
      pButton
      [text]="true"
      [rounded]="true"
      class="search-button-inside"
      (click)="isSearchActive && searchTerm ? cancelSearch() : executeSearch()"
      [disabled]="disabled"
      [attr.aria-label]="(isSearchActive && searchTerm ? 'PremiseHazard.List.cancelButton' : ariaLabel) | transloco"
    >
      @if (isLoading) {
        <i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
      } @else {
        <msi-icon [name]="isSearchActive && searchTerm ? 'ic_remove' : 'ic_search'" [size]="20" />
      }
    </button>
  </div>
</div>
